import cn from 'classnames';

import { Badge, Space } from '@sravni/react-design-system';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import { schemaToElement } from '../../../../../../../helpers/schemaToElement';
import blockStyles from '../../../../../block.module.scss';
import type { MainBlockProps } from '../../components/MainBlock';

import styles from './loan.module.scss';

interface LoanProps extends Pick<MainBlockProps, 'logoBlock' | 'bankName' | 'conditions'> {
  label?: string;
}

export const Loan = ({ logoBlock, bankName, conditions, label }: LoanProps) => {
  const isMobile = useIsMobile();
  const [desktopLabel, mobileLabel] = (label ?? ';').split(';');

  return (
    <>
      <Space direction="horizontal" size={8} align="center">
        <div className={blockStyles.logo}>{logoBlock}</div>
        <Heading level={5} className={cn('h-color-D100', blockStyles.clampOneLine)}>
          {bankName}
        </Heading>
      </Space>
      {label ? (
        <div className="h-mt-12">
          <Badge text={isMobile ? mobileLabel : desktopLabel} color="blue" variant="primary" className={styles.label} />
        </div>
      ) : (
        <div className={cn(styles.tag, 'h-mt-12')} />
      )}
      <Space className={cn(styles.conditions, 'h-mt-12', 'h-mb-12')} direction="vertical" size={8}>
        {conditions &&
          conditions.map(({ value, description, SOValue }, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Space direction="horizontal" justify="space-between" key={index}>
              <div className={styles.description}>{description}</div>
              <div className={styles.value}>{SOValue ? schemaToElement(SOValue) : value}</div>
            </Space>
          ))}
      </Space>
    </>
  );
};
